import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { Input, Select, FallbackImage, Render, Button, DocUpload, DatePicker, PaperClip, Viewer } from 'components';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { UserIcon, CancelCircleIcon, CheckCircleIcon, EyeIcon, UploadIcon, PasswordActive, PasswordInactive } from 'assets/icons';
import moment from 'moment';
import { ModeratorService } from 'services';
import { WhiteImage2 } from 'assets/img';

interface Props extends RootState, RouteComponentProps<any> {
	dispatch: any
}

class Create extends React.Component<Props> {

	state = {
		form: {
			name: '',
			city: '',
			email: '',
			birth_city: '',
			gender: '',
			birthdate: '',
			document: '',
			phone: '',
			photo: {},
			password: '',
			nationality_id: Constants.NATIONALITIES.V
		},
		nationalities: [],
		user: null,
		activePassword: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: `${ this.props.match.params?.id ? 'Editar' : 'Registrar' } administrador`,
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async () => {
		const res: any = await ModeratorService.getData({
			_user_id: this.props.match.params?.id
		});
		this.setState({
			nationalities: res.nationalities || []
		},() => {
			if (!res.user && this.props.match.params?.id) {
				this.props.history.replace('/');
			}
			else if (res.user) {
				this.setState({
					form: {
						...this.state.form,
						name: res.user?.name || '',
						city: res.user?.city || '',
						email: res.user?.email || '',
						birth_city: res.user?.birth_city || '',
						gender: res.user?.gender || '',
						birthdate: res.user?.birthdate ? moment(res.user?.birthdate).toDate() : '',
						document: res.user?.document || '',
						phone: res.user?.phone || '',
						photo: {},
						nationality_id: res.user?.nationality_id || '',
					},
					user: res.user
				});
			}
		});
	}

	submit = async () => {
		// @ts-ignore
		const photo = this.state.user?.user_documents?.find((i: any) => i.document_type_id == Constants.DOCUMENT_TYPES.PHOTO);

		// @ts-ignore
		if (!this.state.form.photo?.value && !photo) {
			Globals.showError("Debe enviar la foto de perfil");
			return;
		}

		await ModeratorService.save({
			hasFile: true,
			...this.state.form,
			// @ts-ignore
			photo: this.state.form?.photo?.value,
			user_id: this.props.user?.id,
			birthdate: this.state.form.birthdate ? moment(this.state.form.birthdate).format('YYYY-MM-DD') : '',
			_user_id: this.props.match.params?.id || ''
		});
		Globals.showSuccess(`Se ha ${ this.props.match.params?.id ? 'modificado' : 'creado' } el administrador correctamente`);
		this.props.history.goBack();
	}

	change = (e: any) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		});
	}

	render() {
		const { form } = this.state;
		// @ts-ignore
		const photo = this.state.user?.user_documents?.find((i: any) => i.document_type_id == Constants.DOCUMENT_TYPES.PHOTO);

		return (
			<div id="moderators-create">
				<div className="container-white">
					<PaperClip
						className="profile-image"
                        formats={['png', 'jpg', 'jpeg']}
                        value={''}
                        onChange={(e: any) => {
                        	this.setState({
                              form: {
                              	...this.state.form,
                              	photo: e.target
                              }
                            });
                        }}>
                        {/*
                        // @ts-ignore */}
                       	<img src={ this.state.form.photo?.dataURL || photo?.file && (Constants.BASE_STORAGE + photo?.file) || WhiteImage2 } />
	                </PaperClip>
					<div className="row">
						<div className="col-md-6">
							<div className="input-group">
								<p className="label">Cédula</p>
								<div className="select-container">
									<Select
										name="nationality_id"
										onChange={ (e: any) => this.change(e) }
										value={ form.nationality_id }
										options={ this.state.nationalities.map((item: any) => {
											return {
												value: item.id,
												label: item.code
											}
										}) }
									/>
									<Input
										type="number"
										value={form?.document}
										name="document"
										onChange={ (e: any) => this.change(e) }
										notMui
									/>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="input-group">
								<Input
									label="Nombre"
									value={form?.name}
									name="name"
									onChange={ (e: any) => this.change(e) }
									notMui
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="input-group">
								<DatePicker
				                          label="Fecha de nacimiento"
				                          placeholder="Fecha"
				                          maxDate={moment().toDate()}
				                          onChange={(date: string) => {
				                            this.setState({
				                              form: {
				                              	...this.state.form,
				                              	birthdate: date
				                              }
				                            });
				                          }}
				                          value={this.state.form.birthdate}
				                        />
				                    </div>
				            </div>
			                	<div className="col-md-6">
			                    	<div className="input-group">
								<Input
									label="Lugar de nacimiento"
									value={form?.birth_city}
									name="birth_city"
									onChange={ (e: any) => this.change(e) }
									notMui
								/>
							</div>
						</div>
						<div className="col-md-6">
		                    		<div className="input-group">
								<Select
									label="Sexo"
									name="gender"
									onChange={ (e: any) => this.change(e) }
									value={ form.gender }
									options={ [
										{ value: 'M', label: 'Masculino' },
										{ value: 'F', label: 'Femenino' },
									] }
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="input-group">
								<Input
									label="Teléfono"
									value={form?.phone}
									name="phone"
									onChange={ (e: any) => this.change(e) }
									notMui
									type="number"
									maxLength={ 11 }
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="input-group">
								<Input
									label="Zona donde reside"
									value={form?.city}
									name="city"
									onChange={ (e: any) => this.change(e) }
									notMui
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="input-group">
								<Input
									label="Correo electrónico"
									value={form?.email}
									name="email"
									onChange={ (e: any) => this.change(e) }
									notMui
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="input-group" style={{ alignItems: 'center' }}>
								<Input
									type={ this.state.activePassword ? 'text' : 'password' }
									label={ this.props.match?.params?.id != null ? 'Cambiar contraseña (Opcional)' : `Contraseña` }
									value={form?.password}
									name="password"
									onChange={ (e: any) => this.change(e) }
									notMui
								/>
								<div className="input-group-prepend password-view" onClick={ () => {
									this.setState({
										activePassword: !this.state.activePassword
									});
								} }>
									<img src={ this.state.activePassword ? PasswordActive : PasswordInactive } />
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="text-right" style={{ maxWidth: '1000px', margin: '0 auto' }}>
					<div className="row row-buttons">
						<div className="col-md-6">
							<button className="btn" onClick={ () => this.props.history.goBack() }>
								Atras
							</button>
						</div>
						<div className="col-md-6">
							<button className="btn btn-blue" onClick={ () => this.submit() }>
								Guardar
							</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Create);